import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { IStockInput } from "../domain/IStockInput";
import {
  getStateOfStockInput,
  selectState,
} from "../slices/dtStockInput.slice";
import InfoTooltip from "components/Popup/InfoTooltip";
import { FormatDateShort } from "utils/dateUtils";

export const StockInputPreview = () => {
  const { stockInputs, loading } = useSelector(selectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getStateOfStockInput());
  }, [dispatch]);

  return (
    <div className="daily-table-stock-inputs loading-container">
      {loading && <Loader />}
      <div className="classicHeader bolded red">LAGER</div>
      <div className="previewBody">
        {stockInputs.map((input: IStockInput) => (
          <div className="singleLager">
            <InfoTooltip
              tooltip={input.itemName}
              classesProp="daily-table-resource-stock-inputs-name text-overflow"
              element="span"
            >
              {input.itemName}
            </InfoTooltip>
            <span className="daily-table-resource-stock-inputs-quantity-total">{input.quantityAmountTotal}</span>
            <span className="daily-table-resource-stock-inputs-quantity-unit">{input.itemQuantityUnit.name}</span>
            <span className="daily-table-resource-stock-inputs-quantity-total-label">nabavljeno</span>
            <span className="daily-table-resource-stock-inputs-quantity-remaining">
              {input.quantityAmountRemaining}
            </span>
            <span className="daily-table-resource-stock-inputs-quantity-remaining-label">kol. ostalo</span>
            <span className="daily-table-resource-stock-inputs-price">{input.pricePerUnit}</span>
            <span className="daily-table-resource-stock-inputs-price-label">cena</span>
            <span className="daily-table-resource-stock-inputs-date">{FormatDateShort(input.procurementDate)}</span>
            <InfoTooltip
              tooltip={`${input.billOfLandingId ?? ''} ${input.itemCode ?? ''} Vozač: ${input.driverName ?? ''}`}
              classesProp="daily-table-resource-stock-inputs-footer text-overflow"
              element="span"
            >
              {input.billOfLandingId} {input.itemCode} Vozač: {input.driverName}
            </InfoTooltip>
          </div>
        ))}
        {stockInputs.length < 3 && <div className="singleLager"></div>}
        {stockInputs.length < 2 && <div className="singleLager"></div>}
        {stockInputs.length < 1 && <div className="singleLager"></div>}
      </div>
    </div>
  );
};
